import { API_BASE_URL } from "../config"

// Servicio PÚBLICO (sin token) para la encuesta de registro de parqueaderos.
// Envía al endpoint abierto /api/sucursales/registro-publico del backend real.
const BASE_URL = `${API_BASE_URL}/api/sucursales`

const registroParqueaderoService = {
  /**
   * Formatea los datos del formulario al contrato de SucursalCreateRequest.
   * @param {Object} form - Estado del formulario.
   * @returns {Object} payload listo para enviar.
   */
  formatData(form) {
    return {
      nombre: form.nombre,
      ubicacion: form.ubicacion,
      empresaId: 4, // empresa fija (también se fuerza en el backend)
      preciotarifa: Number.parseFloat(form.preciotarifa),
      latitud: Number.parseFloat(form.latitud),
      longitud: Number.parseFloat(form.longitud),
      estado: 0, // Activo (también se fuerza en el backend)
      plazas: Number.parseInt(form.plazas, 10),
      descripcion: form.descripcion?.trim() || null,
      horaApertura: form.horaApertura ? `${form.horaApertura}:00` : null,
      horaCierre: form.horaCierre ? `${form.horaCierre}:00` : null,
      // Lista de URLs de fotos, descartando vacías
      fotografias: (form.urls || []).map((u) => u.trim()).filter((u) => u.length > 0),
    }
  },

  /**
   * Registra un parqueadero desde la encuesta pública.
   * @param {Object} data - payload ya formateado (ver formatData).
   * @returns {Promise<Object>} SucursalResponse del servidor.
   */
  async save(data) {
    const response = await fetch(`${BASE_URL}/registro-publico`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })

    if (!response.ok) {
      const errorText = await response.text()
      throw new Error(`Error ${response.status}: ${errorText || "Sin detalles"}`)
    }

    return response.json()
  },
}

export default registroParqueaderoService
